/* Create by BaiZhiming 2015-12-03*/
'use strict';
angular
    .module('editingCenterServiceModule', [
        'feedPopupModule',
        'relatedReportModule',
        'shareModule',
        'manuscriptShare',
        'distribution',
        'draftlistModule',
        'infoAlertModule',
        'warnAlertModule',
        'signedRankModule',
        'fgdIframeModule',
        'editOutSendingModule',
        'draftImportModule',
        'qrCodeModule',
        'timingSignModule',
        'batchGeneratingModule',
        'atlasFixedModule',
        'beforeonloadModule',
        'draftlistForWeiboModule',
        'modifyNameModule',
        'sourceManagementModule',
        'tenantShareManuModule',
        'editchannelsReviseModule',
        'editCenUploadVideoForXjModule',
        'newMediaServiceModule', // 新媒体渠道服务
        'multiImgsWatermarkModule', // 一键水印弹窗
        'processingMaterialServiceModule',
        'commonModalWithTreeModule', // 通用弹窗带树结构
        'fixedPositionModule',
        'strongPromptForBigScreenModule', // 强提醒弹窗
        'picPreviewShowMoreInfoModule', // 图集稿详情页点击单个图片弹窗
        'shareToYdModule', // 共享到已定稿库弹框
        'issuedByForceModule', // 强制签发模块
        'beforeRetractionModule', //取消签发之前的弹框
        'sendToStudioModule', // 发送到工作室的弹框
    ])
    .factory('editingCenterService', [
        '$modal',
        '$state',
        '$compile',
        // '$injector',
        '$location',
        '$filter',
        '$window',
        '$stateParams',
        '$q',
        '$injector',
        'trsHttpService',
        'initVersionService',
        'trsspliceString',
        'modalDialog',
        '$timeout',
        'Upload',
        'editPreviewPath',
        'editingMediatypeToPlat',
        '$sessionStorage',
        'storageListenerService',
        'editorPath',
        'editIsLock',
        'globleParamsSet',
        'localStorageService',
        'stockApiService',
        'messagePublishService',
        'publicToolService',
        function (
            $modal,
            $state,
            $compile,
            // $element,
            $location,
            $filter,
            $window,
            $stateParams,
            $q,
            $injector,
            trsHttpService,
            initVersionService,
            trsspliceString,
            modalDialog,
            $timeout,
            Upload,
            editPreviewPath, // 采编中心查看页路径
            editingMediatypeToPlat,
            $sessionStorage,
            storageListenerService, // 不要删除eval表达式要使用
            editorPath, // 编辑页路径
            editIsLock,
            globleParamsSet,
            localStorageService,
            // editingCenterWeiBoService
            stockApiService,
            messagePublishService,
            publicToolService
        ) {
            // 渠道统一适配
            var mediaObj = {
                currentMediaType: null,
                '17': {
                    mediaZHName: '抖音',
                    mediaENName: 'trill',
                    accountId: 'accountid', // 这里使用适配器模式进行参数适配
                    articleId: 'douyinarticleid',
                },
                '18': {
                    mediaZHName: '百家号',
                    mediaENName: 'baijiahao',
                    accountId: 'baijiahaoaccount',
                    articleId: 'baijiahaoarticleid',
                },
                '19': {
                    mediaZHName: '企鹅号',
                    mediaENName: 'qiehao',
                    accountId: 'qiehaoaccount',
                    articleId: 'qiehaoarticleid',
                },
                '20': {
                    mediaZHName: '头条号',
                    mediaENName: 'toutiaohao',
                    accountId: 'account',
                    articleId: 'articleid',
                },
            };
            var newsAddPaperType = {
                '待用稿': '0',
                '今日稿': '1',
                '上版稿': '2',
                '已签稿': '3',
                '归档稿': '3',
            };
            var platform = {
                '待编': '0',
                '待审': '1',
            };
            var modalName = {
                receivedoc: 'iwo.received',
                docrecord: 'iwo.docrecord',
                persondoc: 'iwo.personal',
                deptdoc: 'iwo.personal',
            };

            /** 获取可多元分发的站点
             * [getWebsitesByDocIds description]
             * @return {[type]} [description]
             */
            function getWebsitesByDocIds(mediaType, docType) {
                var deferred = $q.defer();
                var params;
                params = {
                    serviceid: 'mlf_mediasite',
                    methodname: 'queryAllProductsByDuoYuan',
                    mediaType: mediaType,
                    docType: docType,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    if (data.length) {
                        deferred.resolve(data);
                    } else {
                        deferred.reject();
                    }
                }, function () {
                    deferred.reject();
                });
                return deferred.promise;
            }

            /**
             * [reviseSuccessed description] 修订后的回调
             * @param   {[type]}  data  [data description]返回值
             * @return  {[type]}        [return description]
             */
            function reviseSuccessed(data) {
                modalDialog.alertType('修订成功', '', 'success', false, function () {
                    var temp = mediaObj[mediaObj.currentMediaType].mediaENName.replace(/(\w)/, function (v) {
                        return v.toUpperCase();
                    });
                    eval('storageListenerService.addListenerTo' + temp + '(\'revise\')');
                    $timeout(function () {
                        top.window.close();
                    }, 2000);
                });
            }

            /**
             * [reviseFailed description] 修订失败后的回调函数
             * @param   {[type]}  data  [data description]
             * @return  {[type]}        [return description]
             */
            function reviseFailed(data) {
                modalDialog.alertType('修订失败', data.message, 'error', 'confirm', function () {
                    var temp = mediaObj[mediaObj.currentMediaType].mediaENName.replace(/(\w)/, function (v) {
                        return v.toUpperCase();
                    });
                    eval('storageListenerService.addListenerTo' + temp + '(\'revise\')');
                    top.window.close();
                });
            }

            /**
             * [judgingManuscript description] 判断稿件是否可供稿
             * @param   {[type]}  data  [data description] 稿件集合
             * @return  {[type]}        [return description]
             */
            function judgingManuscript(data) {
                // 可供稿的稿件类型：新闻、图集、链接、视频、直播
                var docTypeObj = {
                    1: true,
                    2: true,
                    4: true,
                    7: true,
                    8: true,
                };
                var metadataids = [];
                for (var i = 0; i < data.length; i++) {
                    if (docTypeObj[data[i].DOCTYPEID]) {
                        metadataids.push(data[i].METADATAID);
                    } else {
                        modalDialog.alertType('请检查稿件类型, 不允许新闻、图集、链接、视频、直播以外的类型稿件供稿', '', 'warning', false);
                        return;
                    }
                }
                return metadataids.join(',');
            }

            /**
             * [routerToEdit description]
             * @param   {[type]}  params  [params description]获取对应编辑器path
             * @return  {[type]}          [return description]
             */
            function routerToEdit(params) {
                var urlParams;
                var path;
                if (params.mediaType * 1 === 4) {
                    path = 'wxeditpage';
                } else {
                    path = editorPath.path[params.MEDIATYPE][params.DOCTYPEID];
                }
                switch (params.MEDIATYPE) {
                    case '18':
                        urlParams = {
                            baijiahaoaccount: params.BAIJIAHAOACCOUNTID,
                            baijiahaoarticleid: params.METADATAID,
                            baijiahaoplatform: params.plantform || params.PLATFORM,
                        };
                        break;
                    case '20':
                        urlParams = {
                            account: params.CHANNELID,
                            articleid: params.METADATAID,
                            platform: params.plantform || params.PLATFORM,
                        };
                        break;
                    case '19':
                        urlParams = {
                            qiehaoaccount: params.ACCOUNTID,
                            qiehaoarticleid: params.METADATAID,
                            qiehaoplatform: params.plantform || params.PLATFORM,
                        };
                        break;
                    case '3':
                        urlParams = {
                            papermetadataid: params.METADATAID,
                            paperid: params.SITEID,
                            newspapertype: params.newspapertype,
                            channelid: params.CHANNELID,
                        };
                        break;
                    case '2':
                        urlParams = {
                            wzchannelid: params.CHANNELID,
                            wzchnldocid: params.CHNLDOCID,
                            wzmetadataid: params.METADATAID,
                            wzsiteid: params.siteid,
                            wzplatform: params.wzplatform,
                        };
                        break;
                    case '1':
                        urlParams = {
                            appchannelid: params.CHANNELID,
                            appchnldocid: params.CHNLDOCID,
                            appmetadataid: params.METADATAID,
                            appsiteid: params.SITEID,
                            appplatform: params.appplatform,
                            isbelongtraining: params.isbelongtraining
                        };
                        break;
                    case '4':
                        urlParams = {
                            wxchannelid: params.CHANNELID,
                            wxchnldocid: params.wxchnldocid,
                            wxmetadataid: params.METADATAID,
                            wxplatform: params.wxplatform,
                            isawaitrevise: params.isawaitrevise,
                        };
                        break;
                    case '5': {
                        urlParams = {
                            wbplatform: params.wbplatform,
                            wbchannelid: params.wbchannelid,
                            wbmetadataid: params.METADATAID,
                        };
                        break;
                    }
                    case '15': {
                        urlParams = {
                            tvchannelid: params.CHANNELID,
                            tvchnldocid: params.tvchnldocid,
                            tvmetadataid: params.METADATAID,
                            tvsiteid: params.tvsiteid,
                            tvplatform: params.tvplatform,
                        };
                        break;
                    }
                    case '16': {
                        urlParams = {
                            broadcastchannelid: params.CHANNELID,
                            broadcastchnldocid: params.broadcastchnldocid,
                            broadcastmetadataid: params.METADATAID,
                            broadcastsiteid: params.broadcastsiteid,
                            broadcastplatform: params.broadcastplatform,
                        };
                        break;
                    }
                    case '25':
                        urlParams = {
                            accountid: params.ACCOUNTID || params.PRODUCTID,
                            articleid: params.METADATAID,
                            platform: params.platform || params.PLATFORM,
                            isOriginal: params.ORIGINAL,
                        };
                        break;
                    case '17':
                        urlParams = {
                            accountid: params.DOUYINACCOUNTID || params.PRODUCTID,
                            douyinarticleid: params.METADATAID,
                            platform: params.platform || params.PLATFORM,
                            isOriginal: params.ORIGINAL,
                        };
                        break;
                }
                var routerName = $state.href(path, urlParams);
                return routerName;
            }

            /**
             * [getPlatFromFlag 获取稿件当前所在平台标识]
             * @return  {[type]}  [return description]
             */
            function getPlatFromFlag() {
                const stateNameArr = $state.current.name.split('.');
                const stateName = stateNameArr[stateNameArr.length - 1];
                if (stateName === 'fusionpreview') {
                    if ($state.params.iwomodalname && $state.params.iwomodalname.includes('received')){
                        return 'received';
                    } else {
                        return false;
                    }
                }
                return {
                    todaysDraft: 'jinri',
                    standbyDraft: 'daiyong',
                    pageDraft: 'shangban',
                    signedDraft: 'yiqian',
                    archiveDraft: 'guidang',
                    receivedManuscript: 'received',
                }[stateName] || '';
            }

            /**
             * [getMediaType 获取列表页面的渠道类型]
             * @return  {[type]}  [return description]
             */
            function getMediaType() {
                const stateNameArr = $state.current.name.split('.');
                const stateName = stateNameArr[stateNameArr.length - 2];
                return {
                    iWo: -1,
                    app: 1,
                    website: 2,
                    newspaper: 3,
                    weixin: 4,
                    weibo: 5,
                    television: 15,
                    broadcast: 16,
                    trill: 17,
                    baijiahao: 18,
                    qiehao: 19,
                    toutiaohao: 20,
                }[stateName] || -1;
            }

            /**
             * [getEditPageMediaType 获取编辑页面的渠道类型]
             * @return  {[type]}  [return description]
             */
            function getEditPageMediaType() {
                let mediaType = '';
                const statesMap = {
                    '-1': ['fusionnews', 'fusionatlas', 'fusionlinkdoc', 'fusionvideo', 'fusionlive', 'iwobroadcasttvmanuscript', 'iwoplannedorder'],
                    '1': ['appnews', 'appatlas', 'appwebsite', 'appsubject', 'appactivity', 'appvideo', 'applive', 'appaudio'],
                    '2': ['websitenews', 'websiteatlas', 'websitesubject', 'websitelinkdoc', 'websitevideo'],
                    '3': ['newspapertext', 'newspaperpic'],
                    '4': ['wxeditpage'],
                    '5': ['weiboheadlinesedit', 'weiboedit'],
                    '15': ['televisionmanuscript', 'televisionplannedorder'],
                    '16': ['broadcastmanuscript', 'broadcastplannedorder'],
                    '17': ['trillnews'],
                    '18': ['baijiahaonews', 'baijiahaoatlas', 'baijiahaovideo'],
                    '19': ['qiehaonews', 'qiehaoatlas', 'qiehaovideo'],
                    '20': ['toutiaohaonews', 'toutiaohaovideo']
                };
                const hashMatch = window.location.hash.match(/#\/(\w)*/gi);
                let hashPath;
                if (hashMatch) {
                    hashPath = hashMatch[0].replace('#/', '');
                }
                if (hashPath) {
                    angular.forEach(statesMap, (value, key) => {
                        if (value.indexOf(hashPath) > -1) {
                            mediaType = parseInt(key);
                        }
                    });
                }
                return mediaType;
            }

            /**
             * [getDocType 获取当前编辑页面的稿件类型]
             * @param   {[type]}  typeId  [typeId 稿件类型ID]
             * @return  {[type]}          [return description]
             */
            function getDocType(typeId) {
                return {
                    '1': '新闻',
                    '2': '图集',
                    '3': '专题',
                    '4': '链接',
                    '5': '活动',
                    '7': '视频',
                    '8': '直播',
                    '9': '广电文稿',
                    '11': '串联单',
                    '12': '音频',
                }[typeId] || '';
            }

            /**
             * [getDocTypeId 获取当前编辑页面的文档类型ID]
             * @return  {[type]}  [return description]
             */
            function getDocTypeId() {
                let typeId = -1;
                const typeMap = {
                    '1': ['fusionnews', 'newspapertext', 'websitenews', 'appnews', 'wxeditpage', 'weiboedit', 'weiboheadlinesedit', 'baijiahaonews', 'qiehaonews', 'toutiaohaonews'],
                    '2': ['fusionatlas', 'newspaperpic', 'websiteatlas', 'appatlas', 'baijiahaoatlas', 'qiehaoatlas'],
                    '3': ['websitesubject', 'appsubject'],
                    '4': ['fusionlinkdoc', 'websitelinkdoc', 'appwebsite'],
                    '5': ['appactivity'],
                    '7': ['fusionvideo', 'websitevideo', 'appvideo', 'trillnews', 'baijiahaovideo', 'qiehaovideo', 'toutiaohaovideo', 'kuaishoudraft'],
                    '8': ['fusionlive', 'applive'],
                    '9': ['iwobroadcasttvmanuscript', 'televisionmanuscript', 'broadcastmanuscript'],
                    '11': ['iwoplannedorder', 'televisionplannedorder', 'broadcastplannedorder'],
                    '12': ['appaudio']
                };
                const hashMatch = window.location.hash.match(/#\/(\w)*/gi);
                let hashPath;
                if (hashMatch) {
                    hashPath = hashMatch[0].replace('#/', '');
                }
                if (hashPath) {
                    angular.forEach(typeMap, (value, key) => {
                        if (value.indexOf(hashPath) > -1) {
                            typeId = parseInt(key);
                        }
                    });
                }
                return typeId;
            }

            /**
             * [getEditMode 获取编辑页面的模式-新建/编辑]
             * @return  {[type]}  [return description]
             */
            function getEditMode() {
                let editMode = 'add';
                let mediaType = getEditPageMediaType();
                const editModeMap = {
                    '-1': 'iwometadataid',
                    '1': 'appmetadataid',
                    '2': 'wzmetadataid',
                    '3': 'papermetadataid',
                    '4': 'wxmetadataid',
                    '5': 'wbmetadataid',
                    '15': 'tvmetadataid',
                    '16': 'broadcastmetadataid',
                    '17': 'douyinarticleid',
                    '18': 'baijiahaoarticleid',
                    '19': 'qiehaoarticleid',
                    '20': 'articleid',
                };
                const editModeFlag = editModeMap[mediaType];
                if (window.location.hash.indexOf(editModeFlag) > -1) {
                    editMode = 'edit';
                }
                return editMode;
            }

            /**
            * [getMediaName 获取渠道名称]
            * @param   {[type]}  mediaType  [mediaType 渠道类型ID]
            * @return  {[type]}             [return description]
            */
            function getMediaName(mediaType) {
                return {
                    '-1': 'I我',
                    '1': '客户端',
                    '2': '网站',
                    '3': '纸媒',
                    '4': '微信',
                    '5': '微博',
                    '15': '电视',
                    '16': '广播',
                    '17': '抖音',
                    '18': '百家号',
                    '19': '企鹅号',
                    '20': '头条号'
                }[mediaType] || '';
            }
            /**
             * [shiftWordToRouterParams description] 将返回的文字转换为可以用的参数
             * @param   {[string]}  word  [word description] 后台返回的名称
             * @return  {[string]}        [return description] 可用的路由参数
             */
            function shiftWordToRouterParams(word) {
                return {
                    'daibian': 0, // 三审流程 - 待编
                    'daishen': 1, // 三审流程 - 待审
                    'yiqianfa': 2, // 三审流程 - 已签发
                    'dyg': 0, // 纸媒渠道 - 待用稿
                    'jrg': 1, // 纸媒渠道 - 今日稿
                    'sbg': 2, // 纸媒渠道 - 上版稿
                    'yqg': 3, // 纸媒渠道 - 已签稿
                    'gdg': 4 // 纸媒渠道 - 归档稿
                }[word];
            }
            /**
             * [getDraftStage description] 获取稿件的阶段位置（待编、待审、已签发等）
             * @param   {[object]}  draft         [trenchParams description] 稿件信息
             * @param   {[object]}  trenchParams  [trenchParams description] 渠道信息
             * @return  {[promise]}               [return description]
             */
            function getDraftStage(draft, trenchParams) {
                let defer = $q.defer();
                if (draft && draft.PLATFORM * 1) {
                    defer.resolve(draft.PLATFORM - 1); // PLATFORM是后端返回的标识待编、待审、已签发的字段，跟前端路由参数差1
                }
                else {
                    let basicParams = {
                        serviceid: 'mlf_metadata',
                        methodname: 'getDocPlatform',
                    };
                    let params = angular.extend({}, basicParams, trenchParams);
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(data => {
                        defer.resolve(shiftWordToRouterParams(data.replace(/\"/g, "")));
                    });
                }
                return defer.promise;
            }
            /**
             * [loadManuscriptType description]加载稿件原创
             * @return  {[type]}  [return description]
             */
            function loadManuscriptType(scope, element) {
                let manuscriptType = '<edit-manuscript-type></edit-manuscript-type>';
                manuscriptType = $compile(manuscriptType)(scope);
                element.find('manuscripttypecon').append(manuscriptType);
            }
            return {
                getDraftStage: getDraftStage,
                getDefaultTplForNews: function () {
                    return new Promise(function (resolve) {
                        const params = {
                            ModalName: 'iwo.personal',
                            methodname: 'getGlobalConfig',
                            serviceid: 'zmy_globalconfig'
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((data) => {
                            resolve(data);
                        });
                    })
                },
                getEditMode: function () {
                    return getEditMode();
                },
                getDocTypeId: function () {
                    return getDocTypeId();
                },
                getDocType: function () {
                    return getDocType(getDocTypeId());
                },
                /**
                 * [getDocTypName description] 获取doctype对应的中文名
                 * @param   {[Number]}  docTypeid  [docTypeid description] 稿件类型ID
                 * @return  {[string]}             [return description] 稿件类型中文名
                 */
                getDocTypName: function (docTypeid) {
                    return getDocType(docTypeid)
                },
                getEditPageMediaType() {
                    return getEditPageMediaType();
                },
                getMediaName(mediaType) {
                    return getMediaName(mediaType);
                },
                newsPaperExportDraft: function (scope) {
                    const chnlDocIds = scope.data.selectedArray.map((item) => item.CHNLDOCID).join(',');
                    this.isListDocCanOper(chnlDocIds, scope.requestData).then(function (data) {
                        var params = {
                            serviceid: 'mlf_exportword',
                            methodname: 'exportWordFile',
                            MetaDataIds: trsspliceString.spliceString(scope.data.selectedArray, 'METADATAID', ','),
                        };
                        scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                            function (data) {
                                $window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                            },
                            function (data) {
                                if (data.REPORTS[0].ISSUCCESS === 'true') {
                                    $window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                                }
                            }
                        );
                    });
                },
                getMediaType: function () {
                    return getMediaType();
                },
                getPlatformFlag: function () {
                    return getPlatFromFlag();
                },
                isListDocCanOper: function (chnlDocIds, callback) {
                    const defer = $q.defer();
                    const platformFlag = this.getPlatformFlag();
                    const mediaType = this.getMediaType();
                    if (mediaType !== 3 && mediaType !== -1 || !platformFlag) {
                        defer.resolve({
                            ISSUCCESS: 'true'
                        });
                        return defer.promise;
                    }
                    const params = {
                        serviceid: 'mlf_mediasite',
                        methodname: 'validateDocPlatform',
                        PlatformFlag: platformFlag, // daibian-待编，daishen-待审，yiqianfa-已签发，daiyong-待用稿，jinri-今日搞，shangban-上版稿，yiqian-已签稿， guidang-归档稿
                        MediaType: mediaType, // 1-客户端，2-网站，3-报纸，4-微信，5-微博，15-电视， 16-广播，17-抖音，18-百家号，19-企鹅号，20-头条号
                        ChnlDocIds: chnlDocIds
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                        defer.resolve(data);
                    }, function () {
                        callback && callback();
                        defer.reject();
                    });
                    return defer.promise;
                },

                /**
                 * [feedPopup description] 供稿, 只有iwo的个人稿库和已收稿库以及app的已签发
                 * @param   {[type]}  mediaInfo  [mediaInfo description] 渠道信息，包括渠道类型（mediaType）和稿件ids（metadataids）
                 * @return  {[type]}             [return description]
                 */
                feedPopup: function (mediaInfo) {
                    var defer = $q.defer();
                    // 判断稿件是否可供稿
                    var metadataids = judgingManuscript(mediaInfo.manuscripts);
                    if (metadataids) {
                        mediaInfo.metadataids = metadataids;
                    } else {
                        return;
                    }
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/service/feedPopup/feedPopup.html',
                        windowClass: 'feedPopupDialog',
                        backdrop: false,
                        controller: 'feedPopupCtrl',
                        resolve: {
                            mediaInfo: function () {
                                return mediaInfo;
                            },
                        },
                    });
                    modalInstance.result.then(function (data) {
                        defer.resolve(data);
                    });
                    return defer.promise;
                },

                /**
                 * [relatedReport description] 报题关联服务
                 * @param   {[Object]}  selected  [selected description] 查询稿件关联报题接口所需的稿件id和渠道类型
                 * @param   {[Object]}  type      [type description] 传过去一个类型
                 * @return  {[type]}              [return description]
                 */
                relatedReport: function (selected, type) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: type === 'task' ? './editingCenter/service/relatedReport/main_task.html' : './editingCenter/service/relatedReport/main.html',
                        windowClass: 'modalHasTabel',
                        backdrop: false,
                        controller: 'relatedReportCtrl',
                        resolve: {
                            selected: function () {
                                return selected;
                            },
                            type: function () {
                                return type;
                            },
                        },
                    });
                    modalInstance.result.then(function (result) {
                        defer.resolve(result);
                    });
                    return defer.promise;
                },

                /**
                 * [share description] 共享方法
                 * @param   {[Function]} success   [success description] 共享成功后的回调
                 * @param   {[string]}   supply     [supply description] 兼容供稿逻辑
                 * @return  {[undefined]}           [return description]
                 */
                share: function (success, supply, fail) {
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/service/share/share_tpl.html',
                        windowClass: 'toBeCompiled-Share-window',
                        backdrop: false,
                        controller: 'shareCtrl',
                        resolve: {
                            supply: function () {
                                return supply;
                            },
                        },
                    });
                    modalInstance.result.then(function (result) {
                        success(result);
                    }, function () {
                        fail && fail();
                    });
                },

                /**
                 * [manuscriptShare description]
                 * @param   {[type]}  data     [data description]
                 * @param   {[type]}  success  [success description]
                 * @return  {[type]}           [return description]
                 */
                manuscriptShare: function (data, success) {
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/service/manuscriptShare/manuscriptShare_tpl.html',
                        windowClass: 'manus-share-window',
                        backdrop: false,
                        controller: 'manuscriptShareCtrl',
                        resolve: {
                            shareParams: function () {
                                return {
                                    data: data,
                                };
                            },
                        },
                    });
                    modalInstance.result.then(function (result) {
                        success(result);
                    });
                },
                draftList: function (array, params, success, editFGDParams, callback) {
                    const chnlDocIds = array.map((item) => item.CHNLDOCID).join(',');
                    this.isListDocCanOper(chnlDocIds, callback).then(function (data) {
                        var modalInstance = $modal.open({
                            templateUrl: './editingCenter/service/draftlist/draftlist_tpl.html',
                            windowClass: 'toBeCompiled-draftlist-window',
                            backdrop: false,
                            controller: 'draftlistCtrl',
                            resolve: {
                                draftListParams: function () {
                                    return {
                                        array: array,
                                        params: params,
                                        editFGDParams: editFGDParams,
                                    };
                                },
                            },
                        });
                        modalInstance.result.then(function (result) {
                            if (result === 'success') {
                                success();
                            }
                        });
                    });
                },

                /**
                 * [fixPositionModel description]
                 * @param   {[type]}  obj   [obj description]固定稿件位置
                 * @param   {[type]}  type  [type description]
                 * @return  {function}      [return description]
                 */
                fixPositionModel: function (obj, type) {
                    var deffered = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/service/fixPosition/fixPos_tpl.html',
                        windowClass: 'fix-position-window',
                        backdrop: false,
                        controller: 'fixedPositionCtrl',
                        resolve: {
                            obj: function () {
                                return obj;
                            },
                            type: function () {
                                return type;
                            },
                        },
                    });
                    modalInstance.result.then(function (result) {
                        deffered.resolve(result);
                    }, function (result) {
                        deffered.reject(result);
                    });
                    return deffered.promise;
                },

                beforeRetractionModel: function (obj, confirm) {
                    return $modal.open({
                        templateUrl: './editingCenter/service/beforeRetraction/beforeRetraction.html',
                        windowClass: 'beforeRetractionModel',
                        backdrop: false,
                        controller: 'beforeRetractionCtrl',
                        animation: false,
                        resolve: {
                            obj: function () {
                                return obj;
                            },
                            callback: function () {
                                return confirm;
                            },
                        },
                    });
                },

                /**
                 * [draftListForFgd description] 微博发稿单弹窗
                 * @param   {[str]}  weiboId    [weiboId description] 微博稿id
                 * @param   {[type]}  success    [success description]
                 * @param   {[type]}  draftInfo  [draftInfo description]
                 * @return  {[type]}             [return description]
                 */
                draftListForFgd: function (weiboId, success, draftInfo) {
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/service/draftlist/draftlist_tpl.html',
                        windowClass: 'toBeCompiled-draftlist-window',
                        backdrop: false,
                        controller: 'draftlistForWeiboCtrl',
                        resolve: {
                            weiboId: function () {
                                return weiboId;
                            },
                            draftInfo: function () {
                                return draftInfo;
                            },
                        },
                    });
                    modalInstance.result.then(function (result) {
                        success(result);
                    });
                },
                rank: function (channelid, item, fixpos, params, success) {
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/service/rank/signed_rank_tpl.html',
                        windowClass: 'signed-rank-window',
                        backdrop: false,
                        controller: 'signedRankCtrl',
                        resolve: {
                            rankParams: function () {
                                return {
                                    channelid: channelid,
                                    item: item,
                                    params: params,
                                    fixpos: fixpos,
                                };
                            },
                        },
                    });
                    modalInstance.result.then(function (result) {
                        if (result === 'success') {
                            success();
                        }
                    });
                },
                // 外发
                outSending: function (transData, successFn, failFn) {
                    if (!transData) {
                        this.doOutSending(transData, successFn);
                    }
                    else {
                        const ChnlDocIds = transData.map((item) => item.CHNLDOCID).join(',');
                        this.isListDocCanOper(ChnlDocIds, failFn).then(()=> {
                            this.doOutSending(transData, successFn);
                        });
                    }

                },
                /**
                 * [doOutSending description] 执行外发
                 * @param   {[type]}  transData  [transData description]
                 * @return  {[type]}             [return description]
                 */
                doOutSending: function (transData, successFn) {
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/service/outSending/outSending.html',
                        windowClass: 'edit-outSending-window',
                        backdrop: false,
                        controller: 'editOutSendingCtrl',
                        resolve: {
                            params: function () {
                                return transData;
                            },
                        },
                    });
                    modalInstance.result.then(function (result) {
                        successFn(result);
                    });
                },
                /**
                 * [exportDraft description] 导出
                 * @param   {[type]}  ids  [ids description]
                 * @return  {[type]}       [return description]
                 */
                exportDraft: function (ids) {
                    var params = {
                        serviceid: 'mlf_exportword',
                        methodname: 'exportWordFile',
                        MetaDataIds: ids,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                        function (data) {
                            // window.open(data);
                            window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                        },
                        function (data) {
                            if (data.REPORTS[0].ISSUCCESS == 'true') {
                                window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                            }
                        },
                    );
                },

                /**
                 * [getEditVersionTime description]获得编辑页面的流程版本和操作日志
                 * @param  {[type]} MetaDataId [description]稿件ID
                 * @param  {[type]} page       [description]操作日志分页信息
                 * @param  {[type]} copyarray  [description]上次的日志信息
                 * @return {[type]}            [description]
                 */
                getEditVersionTime: function (MetaDataId, page, copyarray) {
                    var _self = this;
                    var deferred = $q.defer();
                    var params = {
                        serviceid: 'mlf_extversion',
                        methodname: 'queryVersions',
                        MetaDataId: MetaDataId,
                        CURRPAGE: page.CURRPAGE,
                        PAGESIZE: page.PAGESIZE,
                    };
                    var version = {
                        versionTime: [],
                        operationLog: [],
                        operationLogTitle: '',
                        page: '',
                        copyArray: copyarray,
                        group: [],
                        lastVersionid: '',
                        trench: $location.path().split('/')[1],
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        if (data) {
                            var exttype = [];
                            for (var i = 0; i < data.length; i++) {
                                if (data[i].EXTTYPE === '流程版本') {
                                    exttype.push(data[i]);
                                }
                            }
                            version.lastVersionid = exttype.length > 0 ? exttype.shift().OBJECTVERSIONID : '';
                            var urlArray = 'fusionvideo,fusionnews,fusionatlas,fusionlinkdoc,fusionlive';
                            if (urlArray.indexOf(version.trench) > -1) {
                                version.versionTime = initVersionService.getDayContent(data, 'push');
                            } else {
                                version.copyVersionTime = $filter('groupBy')(data, 'MEDIATYPENAME');
                                for (var j in version.copyVersionTime) {
                                    version.versionTime[j] = [];
                                    version.versionTime[j] = version.versionTime[j].concat(
                                        initVersionService.getDayContent(version.copyVersionTime[j]),
                                    );
                                }
                            }
                        }
                        params.serviceid = 'mlf_metadatalog';
                        params.methodname = 'query';
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                            function (data) {
                                if (data.DATA) {
                                    version.copyArray = $filter('unique')(version.copyArray.concat(data.DATA), 'METADATALOGID');
                                    version.group = $filter('groupBy')(version.copyArray, 'MEDIATYPEDESC');
                                    for (var i in version.group) {
                                        version.operationLog[i] = [];
                                        version.operationLog[i] = version.operationLog[i].concat(
                                            initVersionService.getDayContent(version.group[i], 'push'),
                                        );
                                    }
                                    version.operationLogTitle = angular.isDefined(data.DATA[0]) ? data.DATA[0].TITLE : '';
                                    !!data.PAGER ? (version.page = data.PAGER) : (version.page.ITEMCOUNT = 0);
                                    var newversion = _self.calVersion(version);
                                    return deferred.resolve(newversion);
                                }
                            },
                            function () {
                                deferred.reject();
                            },
                        );
                    });
                    return deferred.promise;
                },

                /**
                 * [getPropagandaReview description] 获取宣传部评审流程
                 * @param   {[type]}  mediaType   [mediaType description] 渠道类型参数
                 * @param   {[type]}  metadataid  [metadataid description] 稿件ID
                 * @return  {[type]}              [return description]
                 */
                getPropagandaReview: function (mediaType, metadataid) {
                    var deffer = $q.defer();
                    var params = {
                        serviceid: 'wcm61_socialprocess',
                        methodname: 'queryToJson',
                        objType: mediaType,
                        ObjId: metadataid,
                        isXcb: 1,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        if (Object.prototype.toString.call(data) == '[object Array]') {
                            var propagandaReview = initVersionService.getDayContent(data, 'push');
                            deffer.resolve(propagandaReview);
                        } else {
                            deffer.reject();
                        }
                    });
                    return deffer.promise;
                },

                /**
                 * [calVersion description]处理稿件的操作日历，流程版本，复制稿日志
                 * @param  {[obj]}  item         [description]稿件的信息
                 * @return {[type]}               [description]
                 */
                calVersion: function (version) {
                    var c = 0,
                        g = 0,
                        o = 0,
                        v = 0;
                    var urlArray = 'fusionvideo,fusionnews,fusionatlas,fusionlinkdoc,fusionlive';
                    for (var i in version.copyVersionTime) {
                        // 循环对象判断对象内数组的长度
                        if (version.copyVersionTime[i].length > 0) {
                            c++;
                            break;
                        }
                    }
                    for (var i in version.group) {
                        if (version.group[i].length > 0) {
                            g++;
                            break;
                        }
                    }
                    for (var i in version.operationLog) {
                        if (version.operationLog[i].length > 0) {
                            o++;
                            break;
                        }
                    }
                    if (urlArray.indexOf(version.trench) > -1) {
                        // 如果是iwo的稿件 则version.versionTime是数组 否则是对象
                        if (version.versionTime.length > 0) {
                            v++;
                        }
                    } else {
                        for (var i in version.versionTime) {
                            if (version.versionTime[i].length > 0) {
                                v++;
                                break;
                            }
                        }
                    }
                    version.copyVersionTime = c > 0 ? version.copyVersionTime : undefined;
                    version.group = g > 0 ? version.group : undefined;
                    version.operationLog = o > 0 ? version.operationLog : undefined;
                    version.versionTime = v > 0 ? version.versionTime : undefined;
                    return version;
                },

                /**
                 * [getVersionTime description]获得稿件的操作日历，流程版本，复制稿日志
                 * @param  {[obj]}  item         [description]稿件的信息
                 * @param  {Boolean} hasCopyDraft [description]是否展示复制稿
                 * @param  {Boolean} isUGC [description] 是否为通讯员稿库稿件
                 * @param  {Boolean} isCrossTenant [description] 是否为跨租户的共享稿库
                 * @return {[type]}               [description]
                 */
                getVersionTime: function (item, hasCopyDraft, isUGC, isCrossTenant) {
                    var incomingData = {
                        doctypeid: item.DOCTYPEID,
                        hasCopyDraft: hasCopyDraft,
                        MetaDataId: item.METADATAID || item.DOCID,
                        chnldocid: item.CHNLDOCID,
                        isCrossTenant: isCrossTenant,
                    };
                    // 兼容通讯员稿库的流程版本
                    if (isUGC) {
                        incomingData.doctypeid = item.docType;
                        incomingData.MetaDataId = item.id;
                        incomingData.isUGC = true;
                    }
                    $modal.open({
                        templateUrl: './editingCenter/service/versionTime/versionTimeModal/versionTime.html',
                        windowClass: 'editCompiledobjTime',
                        backdrop: false,
                        resolve: {
                            incomingData: function () {
                                return incomingData;
                            },
                        },
                        controller: 'editiWoObjTimeCtrl',
                    });
                },
                getComment: function (id, currPage) {
                    var defer = $q.defer();
                    var returnParams = {
                        comment: [],
                        voiceObj: {},
                        hasMore: '',
                    };
                    var params = {
                        serviceid: 'mlf_comment',
                        methodname: 'queryComments',
                        CURRPAGE: currPage,
                        MetaDataId: id,
                        PAGESIZE: 20,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                        if (angular.isDefined(data.DATA)) {
                            data.DATA.reverse();
                            returnParams.comment = initVersionService.getDayContent(data.DATA);
                            returnParams.hasMore = data.PAGER.ITEMCOUNT > currPage * params.PAGESIZE;
                            angular.forEach(data.DATA, function (value, key) {
                                if (key + 1 == data.DATA.length) {
                                    defer.resolve(returnParams);
                                }
                            });
                        }
                    });
                    return defer.promise;
                },

                /**
                 * [draftTimeSinged description] 定时签发
                 * @param   {[obj]}  params      [params description] 数据集合
                 * @param   {[str]}  time        [time description] 定时时间
                 * @return  {[promise]}          [return description] promise
                 */
                draftTimeSinged: function (params, time) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/service/timingSign/timingSign_tpl.html',
                        windowClass: 'timing-sign',
                        backdrop: false,
                        resolve: {
                            params: function () {
                                return params;
                            },
                            SetTime: function () {
                                return time;
                            },
                        },
                        controller: 'timingSignCtrl',
                    });
                    modalInstance.result.then(function (result) {
                        if (result === false) {
                            defer.reject(result);
                            return;
                        }
                        var timeParams = {
                            serviceid: params.serviceid ? params.serviceid : 'mlf_websiteoper',
                            methodname: params.methodName || params.methodname,
                            ChnlDocIds: params.ChnlDocIds ? params.ChnlDocIds : trsspliceString.spliceString(params.selectedArray, 'CHNLDOCID', ','),
                            ObjectIds: params.MetaDataIds
                                ? params.MetaDataIds
                                : trsspliceString.spliceString(params.selectedArray, 'METADATAID', ','),
                            MetaDataIds: params.MetaDataIds
                                ? params.MetaDataIds
                                : trsspliceString.spliceString(params.selectedArray, 'METADATAID', ','),
                            ScheduleTime: result,
                            oprType: params.oprType ? params.oprType : '',
                            actionKey: params.actionKey ? params.actionKey : '',
                            mediaTypeDocIds: params.mediaTypeDocIds ? params.mediaTypeDocIds : '',
                            OprTime: params.OprTime ? params.OprTime : '',
                        };
                        defer.resolve(timeParams);
                    });
                    return defer.promise;
                },

                /**
                 * [getKeywordsOrAbstract description] 提取关键字和摘要
                 * @param  {[type]} type    [description] 类型area(表示地域标引),field(领域标引),keywords(关键词抽取)，abstract(摘要)
                 * @param  {[type]} content [description] 正文
                 * @return {[type]}         [description]
                 */
                getKeywordsOrAbstract: function (type, content) {
                    var deferred = $q.defer();
                    if (!content) {
                        deferred.reject('正文为空');
                    }
                    var params = {
                        serviceid: 'mlf_bigdataexchange',
                        methodname: 'getKeywords',
                        markType: type || 'keywords',
                        markContent: content,
                        // needStop:false,//敏感词
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                        function (data) {
                            deferred.resolve(data);
                        },
                        function () {
                            deferred.reject();
                        },
                    );
                    return deferred.promise;
                },

                /**
                 * [editUploaderImg description]编辑图片
                 * @param   {[type]}  uploadImg  [uploadImg description]
                 * @param   {[type]}  success    [success description]
                 * @return  {[type]}             [return description]
                 */
                editUploaderImg: function (uploadImg, success) {
                    var multiImgsUploader = $modal.open({
                        templateUrl: './editingCenter/service/editUploadImg/editImage.html',
                        resolve: {
                            uploadImg: function () {
                                return uploadImg;
                            },
                        },
                        windowClass: 'multiImgsUploader',
                        backdrop: false,
                        controller: 'editImageCtrl',
                    });
                    multiImgsUploader.result.then(function (result) {
                        success(result);
                    });
                },

                /**
                 * [getPermissions description] 获取拥有的渠道权限
                 * @param   {[string]}  doctype   [uploadImg description] 稿件类型
                 * @param   {[boolean]} isSubmit  [success description] 是否是提交
                 * @return  {[promise]}           [return description]
                 */
                getPermissions: function (doctype, isSubmit) {
                    var deferred = $q.defer();
                    var params = {
                        serviceid: 'mlf_mediasite',
                        methodname: 'queryAllSites',
                        docType: doctype,
                        isSubmit: isSubmit,
                    };
                    var status = {};
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                        for (var index = 0; index < data.length; index++) {
                            var type = data[index]['MEDIATYPE'];
                            switch (type) {
                                case '-1':
                                    status.iwo = {
                                        isAccessAuthority: true,
                                    };
                                    break;
                                case '1':
                                    status.app = {
                                        isAccessAuthority: true,
                                    };
                                    break;
                                case '2':
                                    status.website = {
                                        isAccessAuthority: true,
                                    };
                                    break;
                                case '3':
                                    status.newspaper = {
                                        isAccessAuthority: true,
                                    };
                                    break;
                                case '4':
                                    status.weixin = {
                                        isAccessAuthority: true,
                                    };
                                    break;
                                case '5':
                                    status.weibo = {
                                        isAccessAuthority: true,
                                    };
                                    break;
                                case '15':
                                    status.television = {
                                        isAccessAuthority: true,
                                    };
                                    break;
                                case '16':
                                    status.broadcast = {
                                        isAccessAuthority: true,
                                    };
                                    break;
                                case '17':
                                    status.tiktok = {
                                        isAccessAuthority: true,
                                    };
                                    break;
                                case '18':
                                    status.baijiahao = {
                                        isAccessAuthority: true,
                                    };
                                    break;
                                case '19':
                                    status.qiehao = {
                                        isAccessAuthority: true,
                                    };
                                    break;
                                case '20':
                                    status.toutiao = {
                                        isAccessAuthority: true,
                                    };
                                    break;
                                case '25':
                                    status.kuaishou = {
                                        isAccessAuthority: true,
                                    };
                                    break;
                            }
                        }
                        deferred.resolve(status);
                    });
                    return deferred.promise;
                },

                /**
                 * [closeWinow description]关闭页面服务
                 * @param  {Boolean} isDirty        [description]表单是否遭到改动
                 * @param  {Boolean} isChangeEditor [description]编辑器是否遭到改动
                 * @return {[type]}                 [description]null
                 */
                closeWinow: function (isDirty, isChangeEditor) {
                    var deferred = $q.defer();
                    if (isDirty || isChangeEditor) {
                        modalDialog.alertType(
                            '是否先保存已填写的内容？',
                            '',
                            'ask',
                            true,
                            function () {
                                deferred.resolve();
                            },
                            function () {
                                deferred.reject();
                            },
                        );
                    } else {
                        deferred.reject();
                    }
                    return deferred.promise;
                },

                /**
                 * [imageUpload description]图集稿图片批量上传
                 * @param  {[boolean]} showAddPersonalMaterial [description]是否显示上传到个人素材的checkbox
                 * @param  {[fun]} success [description]上传成功后的回调
                 * @param  {[fun]} specialCase [description]特殊情况（仅从本地上传）
                 * @param {[array]} [finishFiles] [description] 已经上传成功的图片列表
                 * @return {[type]}         [description]
                 */
                imageUpload: function (showAddPersonalMaterial, success, specialCase, finishFiles) {
                    // var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/service/editUploadImg/multiImageUploader.html',
                        windowClass: 'multiImgsUploader',
                        backdrop: false,
                        resolve: {
                            specialCase: function () {
                                return specialCase;
                            },
                            finishFiles: function () {
                                return finishFiles;
                            },
                            showAddPersonalMaterial: function () {
                                return showAddPersonalMaterial;
                            },
                        },
                        controller: 'multiImgsUpladerCtrl',
                    });
                    modalInstance.result.then(function (result) {
                        result.sort(function (x, y) {
                            return x.APPSORT > y.APPSORT ? 1 : -1;
                        });
                        for (var i = 0; i < result.length; i++) {
                            delete result[i].APPSORT;
                        }
                        success(result);
                        // deffer.resolve(result);
                    });
                    // return defer.promise;
                },

                /**
                 * [mediaSelector 素材库图片和视频选择器]
                 *
                 * @param   {[type]}  isMultiple  [isMultiple 是否多选，true-多选；false-单选]
                 * @param   {[type]}  type        [type 素材类型 '0'-图片；'2'-视频; '1'-音频]
                 * @param   {[type]}  maxSize     [maxSize 最多选择多少项,0-不限制]
                 * @param   {[type]}  isResolve   [isResolve 是否解决promise]
                 * @param   {[type]}  success     [success 上传成功后的回调]
                 *
                 * @return  {[type]}              [return description]
                 */
                mediaSelector: function (options) {
                    var that = this;
                    var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './components/util/trsMediaSelector/template/trsMediaSelector_tpl.html',
                        windowClass: 'mediaSelector',
                        backdrop: false,
                        resolve: {
                            options: function () {
                                return options;
                            },
                        },
                        controller: 'mediaSelectorCtrl',
                    });
                    modalInstance.result.then(function (result) {
                        return that.addDefaultTplForXJRB(result);
                    }).then((result) => {
                        if (!options.isResolve && options.success) {
                            options.success(result);
                        } else {
                            deffer.resolve(result);
                        }
                    });
                    return deffer.promise;
                },

                // isXJRB: function () {
                //     return new Promise((resolve, reject) => {
                //         publicToolService.getModeconfiguration('differentEnv','managementConfiguration').then(
                //             (config) => {
                //                 // 如果是非新疆环境直接resolve掉存在这个字段标识环境不同
                //                 if(config.env === "product") {
                //                     resolve();
                //                     return ;
                //                 }
                //                 let xjrbTenantId = localStorageService.get('xjrbTanantId');
                //                 const curTenantId = $sessionStorage.get('curUserInfo') ? $sessionStorage.get('curUserInfo').TENANTID : '';
                //                 if (xjrbTenantId) {
                //                     if (parseInt(xjrbTenantId.replace(/\"/g, '')) === parseInt(curTenantId)) {
                //                         resolve();
                //                     } else {
                //                         reject();
                //                     }
                //                 } else {
                //                     const params = stockApiService.getGongGaoTenantIdParam();
                //                     stockApiService.getGongGaoTenantId(params).then((data) => {
                //                         if (parseInt(data.replace(/\"/g, '')) === parseInt(curTenantId)) {
                //                             localStorageService.set('xjrbTanantId', data);
                //                             resolve();
                //                         } else {
                //                             reject();
                //                         }
                //                     });
                //                 }
                //             },
                //             ()=> {
                //                 resolve();
                //             }
                //         );
                //     });
                // },

                /**
                 * [addDefaultTplForXJRB 新建日报图集稿图片说明添加默认模板]
                 *
                 * @param   {[type]}  result  [result description]
                 *
                 * @return  {[type]}          [return description]
                 */
                addDefaultTplForXJRB: function (result) {
                    const that = this;
                    return new Promise((resolve, reject) => {
                        const doctype = that.getDocType();
                        const editMode = that.getEditMode();
                        if (doctype === '图集' && editMode === 'add') {
                            resolve(result);
                            // that.isXJRB().then(() => {
                            //     that.getDefaultTplForNews().then((data) => {
                            //         if (data) {
                            //             let tpl = data.PIC_MESSAGE_HEADER || '';
                            //             const curUserName = $sessionStorage.get('curUserInfo') ? $sessionStorage.get('curUserInfo').TRUENAME : '';
                            //             tpl = tpl.replace('${current_user}', curUserName);
                            //             angular.forEach(result.list, function (item, index) {
                            //                 result.list[index].resourcetitle += ' ' + tpl;
                            //             });
                            //             resolve(result);
                            //         } else {
                            //             resolve(result);
                            //         }
                            //     });
                            // }, () => {
                            //     resolve(result);
                            // });
                        } else {
                            resolve(result);
                        }
                    });
                },

                /**
                 * [mediaSelector 以图搜图]
                 * @param   {[type]}  options  [options 参数]
                 * @return  {[type]}              [return description]
                 */
                picSearch: function (options) {
                    var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './resourceCenter/materialResource/directive/picSearch/template/picSearch_tpl.html',
                        windowClass: 'mediaSelector',
                        backdrop: false,
                        resolve: {
                            options: function () {
                                return options;
                            },
                        },
                        controller: 'picSearchCtrl',
                    });
                    modalInstance.result.then(function (result) {
                        if (!options.isResolve && options.success) {
                            options.success(result);
                        } else {
                            deffer.resolve(result);
                        }
                    });
                    return deffer.promise;
                },

                /**
                 * [imageUpload description]用于个人素材的图片上传
                 * @param  {[fun]} success [description]上传成功后的回调
                 * @param  {[fun]} specialCase [description]特殊情况（仅从本地上传）
                 * @return {[type]}         [description]
                 */
                personalMaterialImageUpload: function (success, specialCase) {
                    var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/service/editUploadImg/imageUploaderProgress.html',
                        windowClass: 'imageUploaderProgress',
                        backdrop: false,
                        resovle: {
                            specialCase: function () {
                                return specialCase;
                            },
                        },
                        controller: 'imageUploaderProgressCtrl',
                    });
                    modalInstance.result.then(
                        function (result) {
                            // success();
                            deffer.resolve(result);
                        },
                        function () {
                            deffer.reject();
                        },
                    );
                    return deffer.promise;
                },

                /**
                 * [imageUpload description]用于水印的图片上传
                 * @param  {[fun]} success [description]上传成功后的回调
                 * @param  {[fun]} specialCase [description]特殊情况（仅从本地上传）
                 * @param {[array]} [finishFiles] [description] 已经上传成功的图片列表
                 * @return {[type]}         [description]
                 */
                watermarkMgrImageUpload: function (success, specialCase, finishFiles) {
                    // var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/productManageMent/website/watermarkMgr/template/importTemplate_tpl.html',
                        windowClass: 'watermarkMgr',
                        backdrop: false,
                        resolve: {
                            specialCase: function () {
                                return specialCase;
                            },
                            finishFiles: function () {
                                return finishFiles;
                            },
                        },
                        controller: 'watermarkUpladerCtrl',
                    });
                    modalInstance.result.then(function (result) {
                        result.sort(function (x, y) {
                            return x.APPSORT > y.APPSORT ? 1 : -1;
                        });
                        for (var i = 0; i < result.length; i++) {
                            delete result[i].APPSORT;
                        }
                        success(result);
                        // deffer.resolve(result);
                    });
                    // return defer.promise;
                },

                /**
                 * [checkSaveError description] 检查保存时填写错误的地方
                 *
                 * @param   {[obj]}  form      [form description] 需要检查的表单
                 * @param   {[type]}  formname  [formname description]
                 * @param   {[type]}  $scope    [$scope description]
                 *
                 * @return  {[type]}            [return description]
                 */
                checkSaveError: function (form, formname, $scope) {
                    if (formname.parents('body').length === 0) {
                        return;
                    }
                    var parentStatus,
                        formname = formname.serialize().split(/[&=]/); // 利用ajax的排序方法取出所有name值并分割
                    for (var n = 0; n < formname.length; n++) {
                        if (formname[n] == '' || formname[n].indexOf('%') >= 0) {
                            formname.splice(n, 1);
                            n--;
                        }
                    }
                    var arr = [];
                    delete form.$error.date;
                    delete form.$error.max;
                    delete form.$error.min; // 删除app话题稿多余表单name
                    for (var key in form.$error) {
                        // 取出所有报错的name值
                        arr.push(key);
                    }
                    for (var unfix = arr.length - 1; unfix > 0; unfix--) {
                        // 按errorname在表单中出现的顺序排序
                        for (var i = 0; i < unfix; i++) {
                            if (formname.indexOf(arr[i]) > formname.indexOf(arr[i + 1])) {
                                var temp = arr[i];
                                arr.splice(i, 1, arr[i + 1]);
                                arr.splice(i + 1, 1, temp);
                            }
                        }
                    }
                    // 定位到第一个报错name的位置
                    if (angular.element('[name=' + arr[0] + ']').parents('.body_manuscript_content').length > 0) {
                        // 说明属于稿件信息
                        parentStatus = 'manuscriptInfo';
                    } else {
                        // 否则属于属性信息
                        parentStatus = 'attrInfo';
                    }
                    $scope.status.switch = parentStatus; // 切换头部标签
                    $timeout(function () {
                        // 判断第一个errorname是否为编辑器
                        if (arr[0] === 'content') {
                            angular.element('html,body').animate(
                                {
                                    scrollTop: angular.element('.bigFaceDetailLeft').offset().top - angular.element('body').height() / 2,
                                },
                                'slow',
                            );
                        } else {
                            // 定位到页面中部
                            angular.element('html,body').animate(
                                {
                                    scrollTop: angular.element('[name=' + arr[0] + ']').offset().top - angular.element('body').height() / 2,
                                },
                                'slow',
                            );
                        }
                    }, 300);
                },

                /**
                 * [draftPublish description]稿件预览
                 * @param  {[type]} chnldocid  [description]稿件所在的栏目ID
                 * @return {[type]}            [description]
                 */
                draftPublish: function (chnldocid) {
                    var deffer = $q.defer();
                    var view = {
                        serviceid: 'mlf_metadatacenter',
                        methodname: 'preview',
                        ObjectId: chnldocid,
                    };
                    trsHttpService.httpServer('/wcm/mlfcenter.do', view, 'post', false).then(
                        function (data) {
                            data.EXCEPTIONDETAIL
                                ? modalDialog.alertType('预览失败', data.EXCEPTIONDETAIL.substr(0, 500) + '...', 'error', 'confirm')
                                : $window.open(data.URLS);
                            deffer.resolve();
                        },
                        function () {
                            deffer.reject();
                        },
                    );
                    return deffer.promise;
                },

                /**
                 * [siteid description]
                 * @param   {[number]}  siteid          [siteid description] 站点ID
                 * @param   {[string]}  platform        [platform description] 平台类型
                 * @param   {[boolean]}  isOpenAllSite  [isOpenAllSite description] 是否查询全部栏目
                 * @return  {[promise]}                 [return description] promise对象
                 */
                queryChannelsBySiteid: function (siteid, platform, isOpenAllSite) {
                    var params = {
                        serviceid: 'mlf_mediasite',
                        methodname: 'queryClassifyBySite',
                        SiteId: siteid,
                        platform: platform === 0 ? 8 : platform, // 网站8 app9 对应全部
                        isOpenAllSite: isOpenAllSite,
                    };

                    var defer = $q.defer();
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        defer.resolve(data);
                    });
                    return defer.promise;
                },

                // 按照栏目ID遍历栏目树中的栏目
                queryChnlFromTree: function (chnlTree, channelid) {
                    var deferred = $q.defer();
                    if (!angular.isArray(chnlTree) || angular.isUndefined(channelid)) {
                        deferred.reject(chnlTree);
                    }
                    var iterator = function (hnlTree, channelid) {
                        for (var i in chnlTree) {
                            if (chnlTree[i].CHANNELID === channelid) {
                                deferred.resolve(chnlTree[i]);
                                return;
                            } else if (chnlTree[i].HASCHILDREN && angular.isArray(chnlTree[i].CHILDREN)) {
                                deferred.resolve(iterator(chnlTree[i].CHILDREN, channelid));
                            }
                        }
                    };
                    return deferred.promise;
                },

                /**
                 * [getSiteInfo description]根据站点id查询站点详细信息
                 * @param  {[type]} siteid [description]
                 * @return {[type]}        [description]
                 */
                getSiteInfo: function (siteid) {
                    var channelParams = {
                        serviceid: 'mlf_websiteoper',
                        methodname: 'querySiteNameBySite',
                        ObjectId: siteid,
                    };
                    var deffered = $q.defer();
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), channelParams, 'get').then(function (data) {
                        deffered.resolve(data);
                    });
                    return deffered.promise;
                },
                // 栏目树初始化参数
                channelTreeOptions: function () {
                    return {
                        nodeChildren: 'CHILDREN',
                        allowDeselect: false,
                        dirSelectable: true,
                        injectClasses: {},
                        templateUrl: '../app/components/htmlTemplates/treeTemplate.html',
                        isLeaf: function (node) {
                            return node.HASCHILDREN == 'false';
                        },
                    };
                },
                // 查询平台下的栏目子节点
                queryChildChannel: function (node, type) {
                    var params = {
                        serviceid: 'mlf_mediasite',
                        methodname: 'queryClassifyByChnl',
                        channelid: node.CHANNELID,
                        platform: type === 0 ? undefined : type,
                    };
                    var defer = $q.defer();
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        defer.resolve(data.CHILDREN);
                    });
                    return defer.promise;
                },

                /**
                 * [getChannelDetail description]获得栏目的具体信息
                 * @param  {[num]} channelid [description]栏目ID
                 * @return {[obj]}           [description]栏目具体信息
                 */
                getChannelDetail: function (channelid) {
                    var deferred = $q.defer();
                    var params = {
                        serviceid: 'mlf_website',
                        methodname: 'queryChannelById',
                        ObjectId: $stateParams.channelid,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        deferred.resolve(data);
                    });
                    return deferred.promise;
                },

                /**
                 * [checkoutDraft description]稿件敏感词查询
                 * @param  {[str]} content [description]稿件正文
                 * @return {[type]}         [description]
                 */
                checkoutDraft: function (content) {
                    var deffered = $q.defer();
                    var params = {
                        typeid: 'zyzx',
                        eventid: 'ckmMark',
                        serviceid: 'mark',
                        markType: 'col',
                        markContent: content,
                        needStop: true,
                    };
                    trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function (data) {
                        deffered.resolve(data);
                    });
                    return deffered.promise;
                },

                /**
                 * [draftImport description] 导入稿件
                 *
                 * @param   {[type]}  serviceid   [serviceid description]
                 * @param   {[type]}  methodname  [methodname description]
                 * @param   {[type]}  channelid   [channelid description]
                 * @param   {[type]}  newfile     [newfile description]
                 * @param   {[type]}  success     [success description]
                 * @param   {[type]}  clearPath   [clearPath description]
                 *
                 * @return  {[type]}              [return description]
                 */
                draftImport: function (serviceid, methodname, channelid, newfile, success, clearPath) {
                    Upload.upload({
                        url: '/wcm/openapi/uploadFile',
                        data: {
                            file: newfile,
                        },
                    }).then(function (resp) {
                        if (resp.data.error) {
                            var num = resp.data.error.replace(/[^0-9]/gi, '');
                            if (num == '0') {
                                modalDialog.alertType('格式错误', '只能上传.docx,.doc,.txt文件', 'error', 'confirm');
                            } else {
                                modalDialog.alertType(resp.data.error, '', 'error', false);
                            }
                            clearPath();
                            return;
                        }
                        var params = {
                            serviceid: serviceid,
                            methodname: methodname,
                            FileName: resp.data.imgName,
                            OriginName: resp.config.data.file.name,
                        };
                        if (!!channelid) {
                            params.ChannelId = channelid;
                        }
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                            function (data) {
                                modalDialog.alertType('导入稿件成功', '', 'success', false);
                                success();
                                clearPath();
                            },
                            function (error) {
                                clearPath();
                            },
                        );
                    });
                },
                // 按照渠道查询站点
                querySitesByMediaType: function (mediaType) {
                    var params = {
                        serviceid: 'mlf_mediasite',
                        methodname: 'queryWebSitesByMediaType',
                        MediaType: mediaType, // APP：1，网站：2，报纸：3，微信：4，微博：5
                        SiteId: '',
                    };
                    var defer = $q.defer();
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        defer.resolve(data);
                    });
                    return defer.promise;
                },

                /**
                 * [siteid description] 根据站点查询栏目
                 * @param   {[number]}  siteid        [siteid description] 站点ID
                 * @param   {[string]}  platform      [platform description] 渠道类型
                 * @param   {[boolean]} isOpenAllSite [isOpenAllSite description] 是否查询全部栏目
                 * @return  {[promise]}               [return description] promise对象
                 */
                queryClassifyBySite: function (siteid, platform, isOpenAllSite) {
                    var params = {
                        serviceid: 'mlf_mediasite',
                        methodname: 'queryClassifyBySite',
                        siteid: siteid,
                        platform: platform,
                        isOpenAllSite: isOpenAllSite,
                    };
                    var defer = $q.defer();
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        defer.resolve(data);
                    });
                    return defer.promise;
                },
                downloadOrgImgList: function (imgArray, attribute, imgname) {
                    var deffer = $q.defer();
                    angular.forEach(imgArray, function (data, index, array) {
                        var fileArray = data.APPFILE.split('.');
                        var type = fileArray[fileArray.length - 1];
                        var a = document.createElement('a');
                        var imgUrl = data[attribute].replace(/_600/, '').replace(/ScaleWidth=600&/, '');
                        a.setAttribute('href', imgUrl);
                        a.setAttribute('download', data[imgname] + '.' + type);
                        a.click();
                    });
                    $timeout(function () {
                        // 假蒙层
                        deffer.resolve();
                    }, 2000);
                    return deffer.promise;
                },

                /**
                 * [generateQrcode description] 生成二维码
                 * @param   {[string]}  inputStringvar      [inputStringvar description] 需要转为二维码的字符串
                 * @return  {[database64]}                  [return description] 二维码数据
                 */
                generateQrcode: function (inputStringvar) {
                    $modal.open({
                        templateUrl: './editingCenter/service/qrCode/qrCode_tpl.html',
                        windowClass: 'qrCodeParent',
                        backdrop: false,
                        controller: 'qrCodeCtrl',
                        resolve: {
                            inputStringvar: function () {
                                return inputStringvar;
                            },
                        },
                    });
                },

                /**
                 * [batchGeneratingNews description]批量生成新闻
                 * @param   {[type]}  item  [item description]
                 * @return  {[type]}        [return description]
                 */
                batchGeneratingNews: function (item) {
                    var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/service/batchGeneratingNews/batchGeneratingNews_tpl.html',
                        windowClass: 'ratingNews',
                        backdrop: false,
                        controller: 'batchGeneratingCtrl',
                        resolve: {
                            item: function () {
                                return item;
                            },
                            platform: function () {
                                return platform;
                            },
                        },
                    });
                    modalInstance.result.then(
                        function (data) {
                            deffer.resolve(data);
                        },
                        function () {
                        },
                    );
                    return deffer.promise;
                },

                /**
                 * [batchMoveNews description] 新闻批量转移
                 * @param   {[type]}  item  [item description]
                 * @return  {[type]}        [return description]
                 */
                batchMoveNews: function (item) {
                    var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/service/batchMoveNews/batchMoveNews_tpl.html',
                        windowClass: 'batchMoveNews',
                        backdrop: false,
                        controller: 'batchMoveNewsCtrl',
                        resolve: {
                            item: function () {
                                return item;
                            },
                            platform: function () {
                                return platform;
                            },
                        },
                    });
                    modalInstance.result.then(
                        function (data) {
                            deffer.resolve(data);
                        },
                        function () {
                        },
                    );
                    return deffer.promise;
                },

                /**
                 * [atlasFixed description] 图集稿图片固定位置弹窗
                 * @param  {[type]} index  [description]
                 * @param  {[type]} counts [description]
                 * @return {[type]}        [description]
                 */
                atlasFixed: function (index, counts) {
                    var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/service/atlasFixed/atlasFixed_tpl.html',
                        windowClass: 'atlasFixed-window',
                        backdrop: false,
                        controller: 'atlasFixedCtrl',
                        resolve: {
                            item: function () {
                                return {
                                    index: index,
                                    counts: counts,
                                };
                            },
                        },
                    });
                    modalInstance.result.then(
                        function (data) {
                            deffer.resolve(data);
                        },
                        function () {
                        },
                    );
                    return deffer.promise;
                },
                // 重命名的模块
                modifyName: function (content, callback) {
                    return $modal.open({
                        templateUrl: './editingCenter/service/modifyName/modifyName_tpl.html',
                        windowClass: 'modify-name-window',
                        backdrop: false,
                        controller: 'modifyNameCtrl',
                        resolve: {
                            transmission: function () {
                                return {
                                    content: content,
                                    callback: callback,
                                };
                            },
                        },
                    });
                },
                // 多元分发
                distribution: function (data, mediaType, docType, type, success) {
                    getWebsitesByDocIds(mediaType, docType).then(function (mediaData) {
                        if (mediaData.length) {
                            var modalInstance = $modal.open({
                                templateUrl: './editingCenter/service/mutilMediasOperModal/mutilMediasOper_tpl.html',
                                windowClass: 'mutilMediaOperWindow',
                                backdrop: false,
                                controller: 'distributionCtrl',
                                resolve: {
                                    shareParams: function () {
                                        return {
                                            data: data,
                                            type: type,
                                            mediaType: mediaType,
                                            docType: docType,
                                            mediaData: mediaData
                                        };
                                    },
                                },
                            });
                            modalInstance.result.then(function (result) {
                                success(result);
                            });
                        } else {
                            modalDialog.alertType('', '没有可多元分发的渠道', 'error', false);
                        }
                    }, function () {
                        modalDialog.alertType('', '没有可多元分发的渠道', 'error', false);
                    });
                },
                isSameDocType: function (data, docTypeKey) {
                    let docType = data[0][docTypeKey];
                    let rs = true;
                    angular.forEach(data, function (item) {
                        if (item[docTypeKey] !== docType) {
                            rs = false;
                        }
                    });
                    return rs;
                },

                /**
                 * [tenantShareManu description]稿库间共享
                 * @param   {[type]}  incomeParams  [incomeParams description]
                 * @return  {[type]}                [return description]
                 */
                tenantShareManu: function (incomeParams) {
                    var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/service/tenantShareManu/main_tpl.html',
                        windowClass: 'tenant-share-manu-window',
                        backdrop: false,
                        controller: 'tenantShareManuCtrl',
                        resolve: {
                            incomeParams: function () {
                                return incomeParams;
                            },
                        },
                    });
                    modalInstance.result.then(
                        function (data) {
                            deffer.resolve(data);
                        },
                        function (error) {
                            deffer.reject();
                        },
                    );
                    return deffer.promise;
                },

                /**
                 * [shareToYd description]共享到已定稿库
                 * @param   {[type]}  incomeParams  [incomeParams description]
                 * @return  {[type]}                [return description]
                 */
                shareToYd: function (incomeParams) {
                    var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/service/shareToYd/shareToYd.html',
                        windowClass: 'toBeCompiled-Share-window',
                        backdrop: false,
                        controller: 'shareToYdCtrl',
                        resolve: {
                            incomeParams: function () {
                                return incomeParams;
                            },
                        },
                    });
                    modalInstance.result.then(
                        function (data) {
                            deffer.resolve(data);
                        },
                        function (error) {
                            deffer.reject();
                        },
                    );
                    return deffer.promise;
                },

                /**
                 * [channelsRevise description] 修订方法
                 * @param   {[type]}  params   [params description]
                 * @param   {[type]}  success  [success description]
                 * @param   {[type]}  fail     [fail description]
                 * @return  {[type]}           [return description]
                 */
                channelsRevise: function (params, success, fail) {
                    if (params.selectedArray) {
                        const ChnlDocIds = params.selectedArray.map((item) => {
                            return item.CHNLDOCID;
                        }).join(',');
                        params.selectedArray = null;
                        delete params.selectedArray;
                        this.isListDocCanOper(ChnlDocIds, fail).then(() => {
                            this.doRevise(params, success, fail);
                        });
                    }
                    else {
                        this.doRevise(params, success, fail);
                    }
                },
                /**
                 * [doRevise description] 执行修订
                 * @param   {[type]}  params   [params description]
                 * @param   {[type]}  success  [success description]
                 * @param   {[type]}  fail     [fail description]
                 * @return  {[type]}           [return description]
                 */
                doRevise: function (params, success, fail) {
                    var transparams = {
                        serviceid: 'mlf_modifydoc',
                        methodname: 'appointDocToUserOfNewMedia',
                        SiteId: $state.params.account,
                        UserId: '',
                    };
                    var transferData = angular.extend(transparams, params);
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/service/channelsRevise/channelsRevise_tpl.html',
                        windowClass: 'newspaper_revise',
                        controller: 'editchannelsReviseCtrl',
                        resolve: {
                            params: function () {
                                return transferData;
                            },
                        },
                    });
                    modalInstance.result.then(function (result) {
                        if (result === 'success') {
                            success(result);
                        } else {
                            fail();
                        }
                    });
                },
                // 修订完成
                reviseFinished: function (params) {
                    mediaObj.currentMediaType = params.MediaType;
                    var transparams = {
                        serviceid: 'mlf_modifydoc',
                        methodname: 'newMediaModifyDocsFinished',
                        NewDocId: $state.params[mediaObj[mediaObj.currentMediaType].articleId],
                    };
                    var transferData = angular.extend(transparams, params);
                    return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), transferData, 'post', true).then(reviseSuccessed, reviseFailed);
                },

                /**
                 * [getUserHeadPic description] 获取用户头像
                 * @param   {[boolean]}  needRefresh     [needRefresh description]是否需要刷新
                 * @return  {[promise]}                  [return description]
                 */
                getUserHeadPic: function (needRefresh) {
                    var defer = $q.defer();
                    // if (localStorageService.get('userHeadPic') && !needRefresh) { // session改变
                    if ($sessionStorage.get('userHeadPic') && !needRefresh) {
                        // defer.resolve(localStorageService.get('userHeadPic')); // session改变
                        defer.resolve($sessionStorage.get('userHeadPic'));
                        return defer.promise;
                    }
                    var params = {
                        serviceid: 'mlf_extuser',
                        methodname: 'getUserHeadPic',
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        var userHeadPic = data.USERHEAD[0].PERPICURL == '' ? './images/user_icon.jpg' : data.USERHEAD[0].PERPICURL;
                        // localStorageService.set('userHeadPic', userHeadPic); // session改变
                        $sessionStorage.set('userHeadPic', userHeadPic);
                        defer.resolve(userHeadPic);
                    });
                    return defer.promise;
                },
                getRecentUsageSources: function (viewValue, params) {
                    var promise;
                    if (!viewValue) {
                        return;
                    }
                    if (promise) {
                        $timeout.cancel(promise);
                        promise = null;
                    }
                    promise = $timeout(function () {
                        var searchParams = {
                            serviceid: 'mlf_personalsource',
                            methodname: 'getRecentUsageSources',
                            SrcName: angular.isObject(viewValue) ? viewValue.SRCNAME : viewValue,
                        };
                        if (params) {
                            searchParams = params;
                        }
                        return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), searchParams, 'post').then(function (data) {
                            return data.DATA ? data.DATA : data;
                        });
                    }, 100);
                    return promise;
                },

                /**
                 * [routerToPreview description]    跳转到对应查看页
                 * @param   {[obj]}     item           [item description]
                 * @param   {[obj]}     extraParams    [extraParams description] 为了扩展额外配置的参数
                 * @return  {[undefined]}              [return description]
                 */
                routerToPreview: function (item, extraParams) {
                    var path = editPreviewPath.path[item.MEDIATYPE]; // 跳转路径
                    // 处理电视和广播的串联单的跳转路径
                    if (item.MEDIATYPE === '15' && item.DOCTYPE === '串联单') {
                        path = 'seriesSheetPreview';
                    }
                    if (item.MEDIATYPE === '16' && item.DOCTYPE === '串联单') {
                        path = 'broadcastseriessheetpreview';
                    }
                    // iwo 广电文稿和串联单是分开的路由
                    if (item.MEDIATYPE === '-1' && item.DOCTYPE === '广电文稿') {
                        path = 'iwomanuscriptpreview';
                    }
                    if (item.MEDIATYPE === '-1' && item.DOCTYPE === '串联单') {
                        path = 'iwoseriessheetpreview';
                    }
                    var params = {};
                    if (editingMediatypeToPlat[item.MEDIATYPE] === 'trill') {
                        return this.showTrillDetail(item);
                    }
                    switch (editingMediatypeToPlat[item.MEDIATYPE]) {
                        case 'iwo':
                            params = {
                                iwochnldocid: item.CHNLDOCID || item.CHANNELDOCID,
                                iwometadataid: item.METADATAID,
                                iwotype: item.DOCTYPEID,
                                iwoplatform: '0',
                                isfromplannedorder: false,
                                // 请求权限用的iwo个人稿库
                                iwomodalname: modalName[item.MODELTYPE],
                            };
                            break;
                        case 'app':
                            params = {
                                appchannelid: item.CHANNELID || 0,
                                appchnldocid: item.CHNLDOCID || item.CHANNELDOCID,
                                appsiteid: item.SITEID || 0,
                                appmetadataid: item.METADATAID,
                                appplatform: item.PLATFORM || 0,
                                appdoctype: item.DOCTYPEID,
                            };
                            break;
                        case 'website':
                            params = {
                                wzchannelid: item.CHANNELID || 0,
                                wzchnldocid: item.CHNLDOCID || item.CHANNELDOCID,
                                wzsiteid: item.SITEID || 0,
                                wzmetadataid: item.METADATAID,
                                wzplatform: item.PLATFORM,
                                wztypeid: item.DOCTYPEID,
                            };
                            break;
                        case 'newspaper':
                            params = {
                                paperid: item.SITEID || 0,
                                bzmetadata: item.METADATAID,
                                newspapertype: item.STATUS ? newsAddPaperType[item.STATUS] : item.PLATFORM,
                                // newspapertype: item.DOCTYPEID
                            };
                            break;
                        case 'weixin':
                            params = {
                                wxchannelid: item.CHANNELID || 0,
                                wxchnldocid: item.CHANNELDOCID,
                                wxmetadataid: item.METADATAID,
                                wxplatform: item.PLATFORM,
                            };
                            break;
                        case 'baijiahao':
                            params = {
                                mediatype: '18',
                                metadataid: item.NEWDOCID || item.METADATAID,
                            };
                            break;
                        case 'qiehao':
                            params = {
                                mediatype: '19',
                                metadataid: item.METADATAID || item.NEWDOCID,
                            };
                            break;
                        case 'toutiaohao':
                            params = {
                                mediatype: '20',
                                metadataid: item.METADATAID,
                                account: item.ACCOUNTID || item.CHANNELID || item.PRODUCTID,
                            };
                            break;
                        case 'weibo':
                            params = {
                                wbmetadataid: item.METADATAID,
                                wbchannelid: item.ACCOUNTIDS || item.PRODUCTID || item.ACCOUNTID || item.CHANNELID,
                                wbplatform: item.PLATFORM,
                            };
                            break;
                        case 'television':
                            params = {
                                tvchannelid: item.CHANNELID,
                                tvchnldocid: item.CHANNELDOCID,
                                tvsiteid: item.SITEID,
                                tvmetadataid: item.METADATAID,
                                tvplatform: '0',
                            };
                            break;
                        case 'broadcast':
                            params = {
                                broadcastchannelid: item.CHANNELID,
                                broadcastchnldocid: item.CHANNELDOCID,
                                broadcastsiteid: item.SITEID,
                                broadcastmetadataid: item.METADATAID,
                                broadcastplatform: '0',
                            };
                            break;
                        case 'gxgk':
                            params = {
                                metadataid: item.METADATAID,
                                type: item.DOCTYPEID,
                            };
                            break;
                        case 'cpgk':
                            params = {
                                guid: item.METADATAID,
                                indexname: 'product_formal_dev;weixin_formal;weibo_formal',
                            };
                            break;
                        case 'xhsnews':
                            params = {
                                docid: item.METADATAID,
                                type: item.DOCTYPE,
                            };
                            break;
                    }
                    // 暂时没弄懂融合编辑器那块的逻辑，iwo里面直播是单独跳转的app的详情页的，先暂时这样处理
                    if (item.MEDIATYPE === '-1' && item.DOCTYPE === '直播') {
                        path = 'appPreview';
                        params = {
                            appchannelid: item.CHANNELID,
                            appchnldocid: item.CHANNELDOCID,
                            appmetadataid: item.METADATAID,
                            appplatform: 0,
                            appdoctype: item.DOCTYPEID,
                        };
                    }
                    if (extraParams) {
                        params = angular.extend(params, extraParams);
                        console.log(params);
                    }
                    var previewUrl = $state.href(path, params);
                    $window.open(previewUrl);
                },

                /**
                 * [routerToEditorWithLock description]跳转编辑器的路由以及稿件解锁
                 *
                 * @param   {[type]}  params  [params description]
                 *
                 * @return  {function}        [return description]
                 */
                routerToEditorWithLock: function (params) {
                    // 当前渠道需要解锁
                    if (!params.noNeedLock) {
                        editIsLock.isLock(params, params.MEDIATYPE).then((data) => {
                            if (data.ISLOCK === 'false') {
                                $window.open(routerToEdit(params));
                            } else {
                                editIsLock.checkUnlockPermissions(params, data).then(function () {
                                    window.open(routerToEdit(params));
                                });
                            }
                        });
                        // 不需要解锁 直接进入到编辑器
                    } else {
                        window.open(routerToEdit(params));
                    }

                },

                /**
                 * [multiImgsWatermark description] 批量水印
                 * @param   {[type]}  image   [image description]
                 * @param   {[type]}  siteId  [siteId description]
                 * @return  {[type]}          [return description]
                 */
                multiImgsWatermark: function (image, siteId, productId, mediaType) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/service/multiImgsWatermark/multiImgsWatermark.html',
                        windowClass: 'trs-edit-img-dlg multiImgsWatermark',
                        backdrop: false,
                        controller: 'multiImgsWatermarkCtrl',
                        resolve: {
                            params: function () {
                                var params = {
                                    images: image,
                                    siteId: siteId,
                                    productId: productId,
                                    mediaType: mediaType
                                };
                                return params;
                            },
                        },
                    });
                    modalInstance.result.then(function (result) {
                        defer.resolve(result);
                    });
                    return defer.promise;
                },

                /**
                 * [modalWithTree description] 打开一个带树指令的弹窗
                 * @param   {[type]}  treeData  [treeData description]
                 * @return  {[type]}            [return description]
                 */
                modalWithTree: function (treeData) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/service/modalHasTree/modal.html',
                        windowClass: 'modalWithTree',
                        backdrop: false,
                        keyboard: false,
                        controller: 'commonModalWithTreeCtrl',
                        resolve: {
                            tree: function () {
                                return {
                                    treeData: treeData,
                                };
                            },
                        },
                    });
                    modalInstance.result.then((data) => {
                        defer.resolve(data);
                    });
                    return defer.promise;
                },

                /**
                 * [examineDoctype description] 检查稿件类型
                 * @param   {[type]}  array  [array description]
                 * @param   {[type]}  type   [type description]
                 * @return  {[type]}         [return description]
                 */
                examineDoctype: function (array, type) {
                    var defer = $q.defer();
                    for (var i = 0; i < array.length; i++) {
                        if (type.indexOf(array[i].DOCTYPE) < 0) {
                            defer.reject();
                            break;
                        }
                    }
                    defer.resolve();
                    return defer.promise;
                },

                /**
                 * [supply description] 供稿方法
                 * @param   {[type]}  params  [params description] 特殊参数
                 * @return  {[type]}          [return description]
                 */
                supply: function (params) {
                    var defer = $q.defer();
                    modalDialog.confirmModal('供稿', '是否确认将所选稿件供稿给新疆日报', function () {
                        var basicParams = {
                            serviceid: 'mlf_fusionmyrelease',
                            methodname: 'personalContribution',
                        };
                        params = angular.extend(basicParams, params);
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function () {
                            modalDialog.alertType('供稿成功', '', 'success', false);
                            defer.resolve();
                        });
                    });
                    return defer.promise;
                },

                /**
                 * [flowVersion description] 获取流程版本
                 * @param   {[ObjectVersionId]}  ObjectVersionId  [params description]  版本ID
                 * @return  {[promise]}  [return description]
                 */
                flowVersion: function (ObjectVersionId) {
                    var defer = $q.defer();
                    var params = {
                        serviceid: 'mlf_extversion',
                        methodname: 'getObjFromVersion',
                        ObjectVersionId: ObjectVersionId,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((data) => {
                        defer.resolve(data);
                    });
                    return defer.promise;
                },

                /**
                 * [getNewsPaperDate description]
                 *
                 * @return  {function}  [return description]见报时间处理
                 */
                getNewsPaperDate: function () {
                    var NewsPaperDate;
                    var time = Number($filter('date')(new Date(), 'HH'));
                    // 如果系统时间大于8点了,就显示第二天上版日期
                    if (time > 8) {
                        NewsPaperDate = new Date().setDate(new Date().getDate() + 1);
                    } else {
                        // 小于8点,就显示当天日期
                        NewsPaperDate = new Date().setDate(new Date().getDate());
                    }
                    return NewsPaperDate;
                },

                /**
                 * [save description] 保存并关闭
                 * @param   {[function]}  save     [save description] 保存方法
                 * @param   {[number]}  delayTime  [save description] 保存延迟时间
                 * @return  {[type]}               [return description]
                 */
                saveAndClose: function (save, delayTime) {
                    let closeDelayTime;
                    closeDelayTime = delayTime ? delayTime : globleParamsSet.closeDelayTime;
                    save(true).then(() => {
                        $timeout(() => {
                            var opened = $window.open('about:blank', '_self');
                            opened.close();
                        }, closeDelayTime);
                    });
                },

                /**
                 * [$scope description]
                 *
                 * @param   {[type]}  $scope  [$scope description]
                 * @param   {[type]}  obj     [obj description]
                 *
                 * @return  {[type]}          [return description]
                 */
                allAppCloseWindow: function ($scope, obj) {
                    var ueditorService = $injector.get('ueditorService');
                    window.unload = function () {
                        ueditorService.deleteLocalVersion($scope.list.METADATAID, obj.typeName);
                    };
                    let _oldOnUnload = window.onunload;
                    window.onunload = function (e) {
                        ueditorService.savePasteState(obj.typeName);
                        localStorageService.remove('uedotor.downloadingpics');
                        switch (obj.typeName) {
                            case 'app':
                                if (obj.hascondition) {
                                    if ($scope.list.ISSECONDREVIEW != '1' || $scope.status.isSignedOrRevoked === false) {
                                        localStorageService.set('unLocakDraft', JSON.stringify({ metadataid: $stateParams.appmetadataid }));
                                    }
                                } else {
                                    localStorageService.set('unLocakDraft', JSON.stringify({ metadataid: $stateParams.appmetadataid }));
                                }
                                break;
                            case 'newsPaper':
                                localStorageService.set('unLocakDraft', JSON.stringify({ metadataid: $stateParams.papermetadataid }));
                                break;
                            case 'iwo':
                                localStorageService.set('unLocakDraft', JSON.stringify({ metadataid: $stateParams.iwometadataid }));
                                break;
                            case 'website':
                                if ($scope.list.ISSECONDREVIEW != '1' || $scope.status.isSignedOrRevoked === false) {
                                    localStorageService.set('unLocakDraft', JSON.stringify({ metadataid: $stateParams.wzmetadataid }));
                                }
                                break;
                            case 'baijiahao':
                                if ($state.params.baijiahaoarticleid) {
                                    localStorageService.set('unLocakDraft', JSON.stringify({ metadataid: $state.params.baijiahaoarticleid }));
                                }
                                break;
                            case 'broadcast':
                                localStorageService.set('unLocakDraft', JSON.stringify({ metadataid: $stateParams.broadcastmetadataid }));
                                break;
                            case 'weixin':
                                localStorageService.set('unLocakDraft', JSON.stringify({ metadataid: $state.params.wxmetadataid }));
                                break;
                            case 'article':
                                if ($state.params.articleid) {
                                    localStorageService.set('unLocakDraft', JSON.stringify({ metadataid: $state.params.articleid }));
                                }
                                break;
                            case 'douyin':
                                if ($state.params.douyinarticleid) {
                                    localStorageService.set('unLocakDraft', JSON.stringify({ metadataid: $state.params.douyinarticleid }));
                                }
                                break;
                            case 'kuaishou': // 新增快手渠道
                                if ($state.params.articleid) {
                                    localStorageService.set('unLocakDraft', JSON.stringify({ metadataid: $state.params.articleid }));
                                }
                                break;    
                            case 'tv':
                                localStorageService.set('unLocakDraft', JSON.stringify({ metadataid: $stateParams.tvmetadataid }));
                                break;
                            case 'qiehao':
                                if ($state.params.qiehaoarticleid) {
                                    localStorageService.set('unLocakDraft', JSON.stringify({ metadataid: $state.params.qiehaoarticleid }));
                                }
                                break;
                            case 'paper':
                                localStorageService.set('unLocakDraft', JSON.stringify({ metadataid: $stateParams.papermetadataid }));
                                break;
                        }
                        if (ueditorService.hasLocalVersion($scope.list.METADATAID, obj.typeName)) {
                            ueditorService.saveContent($scope.list);
                            ueditorService.compareLocalAndServe($scope, obj.typeName, true).then(function (data) {
                                if (data) {
                                    $scope.saveAndClose();
                                } else {
                                    ueditorService.deleteLocalVersion($scope.list.METADATAID, obj.typeName);
                                    _oldOnUnload();
                                }
                            });
                        }
                    };
                },

                /**
                 * [docTypeToUeditor 关闭编辑页窗口]
                 *
                 * @param   {[type]}  docTypeToUeditor  [docTypeToUeditor description]
                 * @param   {[type]}  $scope            [$scope description]
                 *
                 * @return  {[type]}                    [return description]
                 */
                closeWindow: function (docTypeToUeditor, $scope) {
                    var ueditorService = $injector.get('ueditorService');

                    if (ueditorService.hasLocalVersion($scope.list.METADATAID, docTypeToUeditor)) {
                        ueditorService.saveContent($scope.list);
                        ueditorService.compareLocalAndServe($scope, docTypeToUeditor, true).then(function (data) {
                            if (data) {
                                $scope.saveAndClose();
                            } else {
                                ueditorService.deleteLocalVersion($scope.list.METADATAID, docTypeToUeditor);
                                window.close();
                            }
                        });
                    } else {
                        window.close();
                    }
                },

                /**
                 * [params description]
                 *
                 * @param   {[type]}  params  [params description]
                 * requestDatas: 二次请求返回的结果
                 * datas: 初始化的数据
                 * newAttr: 要增加的新属性
                 * @return  {[type]}          [return description]
                 */
                dealSecondRequest: function (params) {
                    angular.forEach(params.datas, function (value, key) {
                        value[params.newAttr] = params.requestDatas[value.METADATAID];
                    });
                },
                strongPromptForBigScreen: function () {
                    var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/service/strongPromptForBigScreen/strongPromptForBigScreen.html',
                        // windowClass: 'atlasFixed-window',
                        backdrop: false,
                        keyboard: false,
                        controller: 'strongPromptForBigScreenCtrl',
                    });
                    return deffer.promise;
                },
                picsPreviewShowMoreInfo: function (data) {
                    var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/service/picPreviewModal/picPreviewModal.html',
                        windowClass: 'pics-preview-show-more-info-window',
                        backdrop: false,
                        // keyboard: false,
                        controller: 'picPreviewShowMoreInfoCtrl',
                        resolve: {
                            data: function () {
                                return data;
                            },
                        },
                    });
                    modalInstance.result.then((data) => {
                        deffer.resolve(data);
                    });
                    return deffer.promise;
                },

                /**
                 * [options description] 强制签发方法
                 *
                 * @param  {[type]}  result   [options description] 重复稿件数据
                 * @param  {[type]}  options   [options description] 配置项
                 * @return  {[type]}   [return description]
                 */
                issuedByForce: function (result, options) {
                    var deffer = $q.defer();
                    if (result.REPORTS) {
                        handle(result);
                    } else {
                        if (angular.isDefined(result.status) && result.status === '-1') {
                            modalDialog.alertType(result.message, result.detail, 'error', 'confirm', function () {
                                deffer.reject();
                            }, function () {
                                deffer.reject();
                            });
                        }
                    }

                    /**
                     * [handle description] 排重的具体处理逻辑
                     * @param {objefct} [result] [description] 返回结果参数
                     * @return {[type]} [description]
                     */
                    function handle(result) {
                        let tempArray = []; // 是否有重复稿件
                        for (var i in result.REPORTS) {
                            if (result.REPORTS[i].ERRNO === '1108') {
                                tempArray.push(result.REPORTS[i].RESULT);
                            }
                        }
                        if (tempArray.length !== 0) {
                            modalDialog.multiReportsAlert(result, function () {
                                options = options ? angular.copy(options) : {};
                                options.items = tempArray;
                                noRepeat(options);
                            }, function () {
                                deffer.resolve();
                            }, '重稿详情', '取消');
                        } else {
                            modalDialog.multiReportsAlert(result, function () {
                                deffer.resolve();
                            });
                        }
                    }

                    /**
                     * [noRepeat description] 排重弹窗
                     * @param {String} [options] [description] 配置项
                     * @return {[type]} [description]
                     */
                    function noRepeat(options) {
                        var modalInstance = $modal.open({
                            templateUrl: './editingCenter/service/issuedByForce/issuedByForce_tpl.html',
                            windowClass: 'issued-by-force',
                            backdrop: false,
                            controller: 'issuedByForceCtrl',
                            resolve: {
                                options: function () {
                                    return options;
                                },
                            },
                        });
                        modalInstance.result.then(
                            function (data) {
                                deffer.resolve(data);
                            },
                            function () {
                                deffer.reject();
                            },
                        );
                    }

                    return deffer.promise;
                },
                checkHasNetHead: function (url) {
                    var retunParams = {};
                    if (!url) {
                        retunParams.hasHead = true;
                        return retunParams;
                    } else {
                        var reg = /(^([a-zA-Z]{1,})\:\/{1,2})/;
                        if (url.indexOf('http://') !== 0 && url.indexOf('https://') !== 0 && url.indexOf('ftp://') !== 0) {
                            retunParams.hasHead = false;
                            if (reg.test(url)) {
                                url = url.replace(reg, 'http://');
                                retunParams.url = url;
                            } else {
                                url = 'http://' + url;
                                retunParams.url = url;
                            }
                        } else {
                            retunParams.hasHead = true;
                            retunParams.url = url;
                        }
                        return retunParams;
                    }

                },
                // checkAndAddNetHead: function(url) {
                //     var str = new RegExp('http');
                //     var head = str.test(url) === true ? '' : 'http://';
                //     url = head + url;
                //     return url;
                // }

                // 存储并回显各个渠道筛选条件，如果有新增需要添加的，请在paramsMap里面添加相对应键值对
                dealStorage: function (scope, paramsMap) {
                    var params = {
                        selectedDocType: 'DocType',
                    };
                    var name = $state.current.name; // 当前路由名称，不能再destory事件获取，因为那视名称已经改变了
                    var storage = localStorageService.get('global.state') || {};
                    var userId = $sessionStorage.get('curUserInfo').ID;
                    paramsMap ? Object.assign(params, paramsMap) : '';
                    if (storage[userId] && storage[userId][name]) {
                        Object.assign(scope.data, storage[userId][name]);
                        for (var key in params) {
                            if (scope.data[key]) {
                                scope.params[params[key]] = angular.isDefined(scope.data[key].value) ? scope.data[key].value : scope.data[key];
                            }
                        }
                    }
                    // 控制器销毁事件，通过传进来的$scope来处理
                    scope.$on('$destroy', function () {
                        var storage = localStorageService.get('global.state') || {};
                        var paramsObj = {};
                        for (var key in params) {
                            if (scope.data[key]) {
                                paramsObj[key] = scope.data[key];
                            }
                        }
                        storage[userId][name] = paramsObj;
                        localStorageService.set('global.state', storage);
                    });
                },

                /**
                 * [paramsMap description] 回填条件
                 * @param   {[type]}  paramsMap  [paramsMap description]
                 * @return  {[type]}             [return description]
                 */
                echoCondition: function () {
                    var scope = angular.element($('.editctrCon')).scope();
                    if (!scope || !scope.data) { return; }
                    if (!scope.$root.memorySwitch.global) {
                        scope.requestData && scope.requestData();
                        return;
                    }
                    var params = {
                        selectedDocType: 'DocType',
                    };
                    var name = $state.current.name; // 当前路由名称，不能再destory事件获取，因为那视名称已经改变了
                    var storage = localStorageService.get('global.state') || {};
                    var user = $sessionStorage.get('curUserInfo') || {};
                    var userId = user.ID;
                    if (!userId) {
                        scope.requestData && scope.requestData();
                        return;
                    }
                    scope.paramsMap ? Object.assign(params, scope.paramsMap) : '';
                    if (storage[userId] && storage[userId][name]) {
                        Object.assign(scope.data, storage[userId][name]);
                        for (var key in params) {
                            if (scope.data[key]) {
                                scope.params[params[key]] = angular.isDefined(scope.data[key].value) ? scope.data[key].value : scope.data[key];
                            }
                        }
                    }
                    scope.requestData && scope.requestData();
                },

                /**
                 * 记录条件
                 */
                memoryCondition: function (userId, storage) {
                    var scope = angular.element($('.editctrCon')).scope();
                    if (!scope || !scope.data) { return; }
                    var params = {
                        selectedDocType: 'DocType',
                    };
                    scope.paramsMap ? Object.assign(params, scope.paramsMap) : '';
                    var name = $state.current.name; // 当前路由名称，不能再destory事件获取，因为那视名称已经改变了
                    if (!userId) {
                        var user = $sessionStorage.get('curUserInfo') || {};
                        userId = user.ID;
                        if (!userId) {
                            return;
                        }
                    }
                    // scope.$on('$destroy', function () {
                    var storage = storage || localStorageService.get('global.state') || {};
                    var paramsObj = {};
                    for (var key in params) {
                        if (scope.data[key]) {
                            paramsObj[key] = scope.data[key];
                        }
                    }
                    storage[userId][name] = paramsObj;
                    localStorageService.set('global.state', storage);
                    // });
                },

                /**
                 * [options 百度地图选择器]
                 * @param   {[type]}  options  [options description]
                 * @return  {[type]}           [return description]
                 */
                baiduMap: function (options) {
                    var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './components/util/trsBaiduMap/template/trsBaiduMap_tpl.html',
                        windowClass: 'baiduMap',
                        backdrop: false,
                        resolve: {
                            options: function () {
                                return options;
                            },
                        },
                        controller: 'baiduMapCtrl',
                    });
                    modalInstance.result.then(function (result) {
                        deffer.resolve(result);
                    });
                    return deffer.promise;
                },

                /**
                 * [beforeRetractOper description]取消签发之前的判定是否出来一个取消所有有关的关联
                 *
                 * @param   {[type]}  arr  [arr description]
                 *
                 * @return  {[type]}       [return description]
                 */
                beforeRetractOper: function (arr) {
                    var defer = $q.defer();
                    var params = {
                        serviceid: 'mlf_metaviewdata',
                        methodname: 'queryDuoQianAndZTInfo',
                        ChnlDocIds: trsspliceString.spliceString(arr, 'CHNLDOCID', ','),
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        if (data[0].RELATE.length) {
                            defer.resolve(data);
                        } else {
                            defer.resolve('noneed');
                        }
                    },
                        function (data) {
                            defer.reject(data);
                        });
                    return defer.promise;
                },

                /**
                 * [options app 网站图片裁剪请求图片比例]
                 * @return  {[type]}           [return description]
                 */
                querySettedPicSize: function (channelType) {
                    var params = {
                        methodname: 'getPicsSize',
                    };
                    switch (channelType) {
                        case 'app':
                            params.serviceid = 'mlf_appconfig';
                            params.objectid = $stateParams.appsiteid || $stateParams.siteid;
                            break;
                        case 'website':
                            params.serviceid = 'mlf_websiteconfig';
                            params.channelId = $stateParams.wzchannelid;
                            break;
                    }
                    var defer = $q.defer();
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        defer.resolve(data);
                    });
                    return defer.promise;
                },
                /**
                * [sourceManagement description] 来源管理
                * @return {[type]} [description]
                */
                sourceManagement: function () {
                    var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/service/sourceManagement/sourceManagement_tpl.html',
                        windowClass: 'source-management-window',
                        backdrop: false,
                        controller: 'sourceManagementCtrl',
                    });
                    modalInstance.result.then(
                        function (data) {
                            deffer.resolve(data);
                        },
                        function () { }
                    );
                    return deffer.promise;
                },

                /**
                 * [sendToStudio description]发送到工作室的弹框
                 *
                 * @return  {[type]}  [return description]
                 */
                sendToStudio: function (info) {
                    let params = {
                        fromAccountId: this.getAccountInfo('ID'),
                        messageBodies: info.messageBody.length ? info.messageBody : [info.messageBody],
                        outerSourceId: info.outerSourceId,
                        platform: 'TENCENT_IM',
                        oprType: info.oprType,
                        objId: info.objId
                    };
                    var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/service/sendToStudio/sendToStudio.html',
                        windowClass: 'sendToStudio',
                        backdrop: false,
                        resolve: {
                            params: function () {
                                return params;
                            }
                        },
                        controller: 'sendToStudioCtrl',
                    });
                    modalInstance.result.then(function (result) {
                        deffer.resolve(result);
                    });
                    return deffer.promise;
                },

                /**
                 * [getAccountId 获取当前登录用户的ID]
                 *
                 * @return  {[type]}  [return description]
                 */
                getAccountInfo: function (key) {
                    return $sessionStorage.get('curUserInfo') ? $sessionStorage.get('curUserInfo')[key] : null;
                },
                /**
                 * [queryVerifyDoc description] 查询是否是指定审核人稿件
                 *
                 * @return  {[type]}   [return description]
                 */
                queryVerifyDoc: function (tableData) {
                    var defer = $q.defer();
                    var isArray = angular.isArray(tableData);
                    var params = Object.assign({
                        docIds: !isArray ? tableData.METADATAID : trsspliceString.spliceString(tableData, 'METADATAID', ',')
                    }, {
                        serviceid: 'mlf_fusion',
                        methodname: 'queryVerifyDoc',
                    });
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                        if (isArray) {
                            tableData.forEach(function (item) {
                                Object.assign(item, data[item.METADATAID]);
                                item.verifyDocIsCanOper = !item.isVerifyDoc || (item.isVerifyDoc && item.isLockUser);
                            });
                        } else {
                            Object.assign(tableData, data[tableData.METADATAID]);
                            tableData.verifyDocIsCanOper = !tableData.isVerifyDoc || (tableData.isVerifyDoc && tableData.isLockUser);
                        }
                        defer.resolve();
                    }, function () {
                        defer.resolve();
                    });
                    return defer.promise;
                },

                /**
                 * [initAppendixUpload 动态加载附件信息指令]
                 * @return  {[type]}  [return description]
                 */
                initAppendixUpload: function ($scope) {
                    var appendixUpload =
                        '<appendix-upload-for-edit-page></appendix-upload-for-edit-page>';
                    appendixUpload = $compile(appendixUpload)($scope);
                    angular.element('appendixUpload').append(appendixUpload);
                },
                loadManuscriptType: loadManuscriptType,
                
                /**
                 * [showTrillDetail 展示抖音详情的弹窗]
                 *
                 * @return  {[type]}  [return description]
                 */
                showTrillDetail: function(item){
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/service/trillDetail/trillDetail_tpl.html',
                        windowClass: 'trill-detail-window',
                        backdrop: false,
                        controller: 'trillDetailCtrl',
                        size: '400',
                        resolve: {
                            item: function () {
                                return item;
                            },
                        },
                    });
                    modalInstance.result.then(function (result) {
                        defer.resolve(result);
                    });
                    return defer.promise;
                },

                /*
                 * [uploadAttachment 上传附件弹窗]
                 *
                 * @return  {[type]}  [return description]
                 */
                uploadAttachment: function() {
                    var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './components/util/uploadAttechment/uploadAttachment_tpl.html',
                        windowClass: 'app-upload-attachment-window',
                        backdrop: false,
                        resolve: {},
                        controller: 'uploadAttachmentCtrl',
                    });
                    modalInstance.result.then(function (result) {
                        deffer.resolve(result);
                    });
                    return deffer.promise;
                },

                disabledDndDropOnOutlist: function($scope) {
                    $scope.isDndDragging = false;
                    $scope.dragEnd = function () {
                        $scope.isDndDragging = false;
                    };
                    $scope.dragStart = function () {
                        $scope.isDndDragging = true;
                    };
                    $(document).on('drop', disabledDrag);
                    messagePublishService.subscribe('ueReady', () => {
                        const ue = UE.getEditor('ueditor');
                        $(ue.body).on('drop', disabledDrag);
                    });
                    $scope.$on('$destroy', function() {
                        $(document).un('drop', disabledDrag);
                        const ue = UE.getEditor('ueditor');
                        if (ue) {
                            $(ue.body).un('drop', disabledDrag);
                        }
                    });

                    /**
                     * [disabledDrag 禁止放入]
                     *
                     * @return  {[type]}  [return description]
                     */
                    function disabledDrag() {
                        if ($scope.isDndDragging) {
                            return false;
                        }
                    }
                },

                /**
                 * [getNewspaperOrder description]获得报纸的排序信息
                 *
                 * @return  {[type]}  [return description]
                 */
                getNewspaperOrder: function () {
                    return [
                        {
                            name: '版面排序',
                            value: 'BanMian'
                        },
                        {
                            name: '时间排序',
                            value: 'OperTime'
                        }
                    ];
                },
                
            };
        },
    ]);
